import { createReducer } from '@reduxjs/toolkit'

import { addVoucher, removeVoucher } from '../actions/actions'

const initialState = []

const addedVouchers = createReducer(initialState, {
  [addVoucher]: (state, { payload }) => {
    state.push(payload)
  },
  [removeVoucher]: (state, { payload }) => {
    const index = state.findIndex(({ code }) => payload.code === code)

    if (index > -1) {
      state.splice(index, 1)
    }
  }
})

export default addedVouchers
